import React, { useEffect, useState } from "react";
import _ from "lodash";
import { toast } from "react-toastify";
import RestClient from "../../../../common/RestClient";

const INITIAL_FORM_DATA = {
  patronName: "",
  emailAddress: "",
  phoneNumber: "",
  seatCodes: "",
};

export const DistributeSampleTicketModal = ({
  visible,
  corporateBookingId,
  bookingReference,
  onCancel,
  onSuccess,
}) => {
  const [form, setForm] = useState(INITIAL_FORM_DATA);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setForm(INITIAL_FORM_DATA);
  }, [visible]);

  if (!visible) {
    return null;
  }

  const onInputChange = (event) => {
    const fieldName = event.target.getAttribute("name");
    setForm({
      ...form,
      [fieldName]: event.target.value,
    });
  };

  const onSend = () => {
    const seatCodes = (form.seatCodes || "")
      .split(",")
      .map((x) => x.trim())
      .filter((x) => !_.isEmpty(x));

    if (_.isEmpty(form.patronName)) {
      toast.error("Patron name is required.");
      return;
    }
    if (_.isEmpty(form.emailAddress)) {
      toast.error("Email address is required.");
      return;
    }
    if (_.isEmpty(seatCodes)) {
      toast.error("Seat codes are required.");
      return;
    }

    const emailSubject = `Movie Ticket Confirmation (${bookingReference})`;

    setIsSubmitting(true);
    RestClient.sendPostRequest(
      `/api/v1/corporate_booking_print_and_distribute_tickets/e-tickets/sample`,
      {
        corporateBookingId: +corporateBookingId,
        eTicket: {
          emailSubject,
          patronName: form.patronName,
          emailAddress: form.emailAddress.trim(),
          phoneNumber: form.phoneNumber,
          seatCodes,
        },
      },
      () => {
        setIsSubmitting(false);
        toast.success("Sample confirmation email has been sent successfully.");
        if (onSuccess) onSuccess();
        if (onCancel) onCancel();
      },
      (error) => {
        setIsSubmitting(false);
        toast.error(
          error?.message || "Failed to send sample confirmation email."
        );
      }
    );
  };

  return (
    <>
      <div
        className="modal fade show"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Distribute Sample Ticket</h5>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={onCancel}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="container-fluid">
                <div className="row form-group">
                  <div className="col-md-4">
                    <label className="form-control-label">
                      Patron Name
                      <span className="color-red font-weight-bold">*</span>
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      name="patronName"
                      value={form.patronName}
                      onChange={onInputChange}
                      placeholder="Enter patron name"
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-md-4">
                    <label className="form-control-label">
                      Email Address
                      <span className="color-red font-weight-bold">*</span>
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="email"
                      name="emailAddress"
                      value={form.emailAddress}
                      onChange={onInputChange}
                      placeholder="Enter email address"
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-md-4">
                    <label className="form-control-label">Phone Number</label>
                  </div>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      name="phoneNumber"
                      value={form.phoneNumber}
                      onChange={onInputChange}
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>
                <div className="row form-group">
                  <div className="col-md-4">
                    <label className="form-control-label">
                      Seat Codes
                      <span className="color-red font-weight-bold">*</span>
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input
                      className="form-control"
                      type="text"
                      name="seatCodes"
                      value={form.seatCodes}
                      onChange={onInputChange}
                      placeholder="e.g. A1, A2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={onSend}
                disabled={isSubmitting}
              >
                Send
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={onCancel}
                disabled={isSubmitting}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};
